<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <h1>Érvényes vonalkódok</h1>
          <TabulatorTable v-if="barcodes.length > 0" v-model="barcodes" :options="tabulator_opts" />
        </div>
      </div>

      <HTMLFooter></HTMLFooter>
      <ProgressInfo :show="is_save"/>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
    return {
      barcodes: [],
      errors: [],
      is_save: false,
      tabulator_opts: {
        initialSort: [{column:"barcode_number", dir:"asc"}],
        headerFilterPlaceholder:" ",
        columns: [
          {title:"Vonalkódszám", field:"barcode_number", headerFilter: 'input', sorter: "string", width: '15%'},
          {title:"Felhasználó név", field:"name", headerFilter: 'input', sorter: "string", width: '20%'},
          {title:"Felhasználó email", field:"email", headerFilter: 'input', sorter: "string", width: '20%'},
          {title:"Kezdő dátum", field:"start_date_time", sorter: "datetime", sorterParams: {format:"YYYY-MM-DD hh:mm:ss"}, width: '15%'},
          {title:"Periódus (óra)", field:"period", headerSort:false, width: '10%'},
          {title:"Vég dátum", field:"end_date", sorter: "datetime", sorterParams: {format:"YYYY-MM-DD hh:mm:ss"}, width: '15%'}
        ]
      }
    };
  },
  mounted: function() {
    this.getBarcodes();
  },
  methods: {
    getBarcodes: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('active_barcodes/' + _this.$root.user.apikey, {
          method: 'POST',
          success: function(response) {
            _this.barcodes = response.barcodes;
          }
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// barcodes.vue?12ea6ea2